import React from 'react';
import PropTypes from 'prop-types';
import Drawer from 'material-ui/Drawer';
import Icon from 'material-ui/Icon';
import { MenuItem, MenuList } from 'material-ui/Menu';
import Paper from 'material-ui/Paper';

const Menu = ({ handleCloseClick, handleFilterClick, isopen }) => {
  const output = {};
  if (handleCloseClick) {
    output.closeicon = (
      <Icon color="action" onClick={handleCloseClick} className="close-icon">close</Icon>
    );
  }

  return (
    <Drawer
      open={isopen}
      className="menu-drawer"
    >
      <div>
        <div className="menu-content">
          <Paper className="menu">
            <MenuList>
              <MenuItem onClick={() => handleFilterClick('qatar-charity')}>Qatar Charity</MenuItem>
              <MenuItem onClick={() => handleFilterClick('qcuk')}>UK Branch</MenuItem>
              <MenuItem onClick={() => handleFilterClick('qcuk+history')}>History</MenuItem>
              <MenuItem onClick={() => handleFilterClick('qcuk+leadership')}>Leadership</MenuItem>
            </MenuList>
          </Paper>
          <Paper className="menu">
            <MenuList>
              <MenuItem onClick={() => handleFilterClick('sheffield')}>Emaan Trust of Sheffield</MenuItem>
              <MenuItem onClick={() => handleFilterClick('sheffield+history')}>History</MenuItem>
              <MenuItem onClick={() => handleFilterClick('sheffield+leadership')}>Leadership</MenuItem>
              <MenuItem onClick={() => handleFilterClick('sheffield+funding')}>Funding</MenuItem>
            </MenuList>
          </Paper>
        </div>
        <Icon color="action" onClick={handleCloseClick} className="close-icon">close</Icon>
      </div>
    </Drawer>
  );
};

Menu.propTypes = {
  handleCloseClick: PropTypes.func,
  handleFilterClick: PropTypes.func,
  isopen: PropTypes.bool,
};

export default Menu;



// WEBPACK FOOTER //
// ./scripts/components/Menu.jsx